module.exports = __webpack_public_path__ + "static/media/cross-grey.7d2648f5.svg";